import * as ActionTypes from '../actions/types';
import xs from 'xstream';
import {BASE_URL} from "../helpers/constants";
import * as actions from "../actions";
import sampleCombine from 'xstream/extra/sampleCombine';
import {push} from "react-router-redux";
import {_isDepartmentUser} from "../helpers/functions";

export function requestScoreRecordsAfterFileSubmit(sources) {

  const state$ = sources.STATE;
  const departmentId$ = state$.map(state => state.loggedInPerson.get('departmentId'));
  const roles$ = state$.map(state => state.loggedInPerson.get('roles').toJS());

  const request$ = sources.ACTION
    .filter(action => action.type === ActionTypes.CREATE_SCORE_RECORD_FROM_FILE_SUCCESS)
    .compose(sampleCombine(departmentId$, roles$))
    .map(([action, departmentId, roles]) => actions.getScoreRecords({
      filter: {
        order:  'createdDate DESC',
        include: [
          {relation: 'person', scope: {include: 'department'}},
          {relation: 'scores', scope: {
              include: ['store', {relation: 'criteria', scope: {include: 'department'}}],
              limit: 1
            }}
        ],
        where: _isDepartmentUser(roles)?{departmentId: departmentId}:{}
      }
    }));

  return {
    ACTION: request$
  }
}

export function requestScoreRecordsAfterLogin(sources) {

  const request$ = sources.ACTION
    .filter(action => action.type === ActionTypes.LOGIN_SUCCESS)
    .map(action => push('/score-records'));

  return {
    ACTION: request$,
  }
}

export function requestScoreRecords(sources) {

  const state$ = sources.STATE;
  const token$ = state$.map(state => state.loggedInPerson.get('token'));

  const request$ = sources.ACTION
    .filter(
      action => (
        action.type === ActionTypes.GET_SCORE_RECORDS
      )
    )
    .compose(sampleCombine(token$))
    .map( ([action, token]) => ({
      url: BASE_URL + 'api/scoreRecordCards' + (
        action.payload && action.payload.filter?
          `?filter=${JSON.stringify(action.payload.filter)}`:''
      ) ,
      category: 'requestScoreRecords',
      method: 'GET',
      headers: {Authorization: token},
    }));

  let httpResponse$ = sources.HTTP
    .select('requestScoreRecords')
    .map((response) =>
      response.replaceError((err) => xs.of(err))
    )
    .flatten()
    .filter(response => response.status === 200)
    .map(response => actions.getScoreRecordsSuccess(response));

  return {
    ACTION: httpResponse$,
    HTTP: request$
  }
}

export function requestScoreRecordsFailed(sources) {
  let httpResponse$ = sources.HTTP
    .select('requestScoreRecords')
    .map((response) =>
      response.replaceError((err) => xs.of(err))
    )
    .flatten()
    .filter(response => response.status !== 200)
    .map(response => actions.getScoreRecordsFailed(response));

  return {
    ACTION: httpResponse$
  }
}



// WEBPACK FOOTER //
// ./src/cycles/scoreRecords.js